import { DesignPreviewImageParams, getWebpUrl, makeDesignPreviewUrl } from '../lib/images.js';
import { omit, pick } from '../../common/util.js';
import { Maybe } from '../../common/data.js';
import { ImgHTMLAttributes } from 'preact/compat';

export interface PictureProps extends ImgHTMLAttributes<HTMLImageElement> {
	src: string;
	webp?: Maybe<string>;
}

export function Picture(props: PictureProps) {
	return <img src={props.webp ?? getWebpUrl(props.src)} {...omit(props, 'src')} />;
}

type PropParams = Omit<DesignPreviewImageParams, 'format'>;
const paramKeys: (keyof PropParams)[] = ['previewWidth', 'fullWidth', 'rosterEntry', 'side', 'productTemplate', 'product'];

export interface DesignPictureProps extends ImgHTMLAttributes<HTMLImageElement>, PropParams {
	designId: Maybe<string>;
}

export function DesignPicture(props: DesignPictureProps) {
	const { designId } = props;
	const params = pick(props, paramKeys);
	const attrs = omit(props, 'designId', ...paramKeys);
	return <picture>
		<source srcset={makeDesignPreviewUrl(designId, { ...params, format: 'webp' })} type="image/webp" />
		<img src={makeDesignPreviewUrl(designId, { ...params, format: 'png' })} {...attrs} />
	</picture>;
}
